import { render } from "./Recap.vue?vue&type=template&id=6f8f3b8d&scoped=true"
import script from "./Recap.vue?vue&type=script&lang=js"
export * from "./Recap.vue?vue&type=script&lang=js"

import "./Recap.vue?vue&type=style&index=0&id=6f8f3b8d&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f8f3b8d"]])

export default __exports__